import React from 'react';
import Header from '../header/header';
import AudioguidePromo from '../audioguide-promo/audioguide-promo';
import Painting from '../painting/painting';
import Footer from '../footer/footer';
import './main.css';
import '../mobile/audioguide-promo.css';
import '../mobile/header.css';
import '../mobile/painting.css';
import '../mobile/footer.css';
import '../mobile/test.css';
import '../mobile/slider.css';
import '../mobile/reader.css';

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.handleHover = this.handleHover.bind(this);
    this.handleTestButton = this.handleTestButton.bind(this);
  }

  state = {
    id: 0,
    test: false,
    slidesTotal: 0,
    currentSlide: 0,
    display: false
  };

  componentDidMount() {
    const data = require('../../data.json');
    this.setState({slidesTotal: data.length});
  }

  handleHover(prop) {
    this.setState({id: prop});
  }

  handleTestButton() {
    const test = this.state.test;
    this.setState({test: !test});
  }

  render() {
    const data = require('../../data.json');
    return (
      <div className="index">
        <div
          className="index__background"
          style={{
            backgroundImage:
              'url(./images/painters/PAINTINGS_FULL/angel.jpg)'
          }}
        >
          <div className="index__background-inner" />
        </div>
        <Header />
        <AudioguidePromo />
        <div className="paintings">
          {data.map((element, index) => (
            <Painting
              hoverBlock={this.handleHover}
              index={index}
              key={index}
              painterName={element.painterShortName}
              painting={element.painting}
              reader={element.reader}
              readerIsSmall={element.readerIsSmall}
              readerName={element.readerShortName}
              stateID={this.state.id}
            />
          ))}
        </div>
        <Footer />
      </div>
    );
  }
}

export default Index;
